import _ from 'lodash'
import { getFeatureToggle } from '@vzmi/component_ec_nodejs_util/dist/lib/FeatureToggleUtil'

export const transformSubStationOptions = (subStations = [], flags) => _.flow(
  // APACSMDESK-33447 [SP][一般賣場提案 revamp] 若子站之ＰＭ窗口為空，則不顯示該子站-FE
  nextSubStations => _.filter(nextSubStations, subStationContact => !!subStationContact.id),
  nextSubStations => {
    const kaFeatureToggle = getFeatureToggle(flags, 'sp_KA')
    return _.map(nextSubStations, subStationContact => {
      const { categoryId, categoryName, id, name } = subStationContact
      if (kaFeatureToggle) {
        return {
          label: `(${_.toString(categoryId).replace(/^sub(.*)$/g, '$1')})${categoryName}`,
          value: `${categoryId}`
        }
      }
      return {
        label: `(${_.toString(categoryId).replace(/^sub(.*)$/g, '$1')})${categoryName}-${name}(${id})`,
        value: `${categoryId}`
      }
    })
  }
)(subStations)
